import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef, useEffect,
} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { toast } from 'react-toastify';

import OverLoading from '../global/OverLoading';
import { addAddress, updateAddress } from '../../actions/admin/addressAction';
import { toggleModal } from '../../actions/modal';
import { Trim } from '../../common/util';
import Constants from '../../common/constants';
import Colours from '../../styles/colours';

const FormCreate = forwardRef((props, ref) => {
  const submitButtonRef = useRef();

  useImperativeHandle(ref, () => ({
    submitForm() {
      submitButtonRef.current.click();
    },
  }));

  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [formData, setFormData] = useState({
    id:             '',
    name:           '',
    address:        '',
    postalCode:     '',
    lat:            '',
    lng:            '',
    type:           '',
    allowDuplicate: false,
  });

  const { name, address, postalCode, lat, lng, type } = formData;

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e, allowDuplicate) => {
    e.preventDefault();
    setLoading(true);

    if (allowDuplicate) {
      formData.allowDuplicate = true;
    }

    formData.name = Trim(formData.name, false, true);

    try {
      if (props.addressData) {
        await props.updateAddress(formData, formData.id).then((response) => {
          setLoading(false);
          if (response.status === 200) {
            props.toggleModal();
            toast.success('Address has been updated.');

            // callback
            props.updateList();
            props.reloadPostalCodeTable();
          } else {
            toast.error('An unexpected error has occurred');
          }
        });
      } else {
        await props.addAddress(formData).then((response) => {
          if (response.status === 200) {
            props.toggleModal();
            toast.success('Address has been added.');

            // callback
            props.updateList();
            props.reloadPostalCodeTable();
          } else {
            toast.error('An unexpected error has occurred');
          }
        });
      }
    } catch (err) {
      if (err && err === Constants.Error.PostalCodeAlreadyExist) {
        setOpenModal(true);
      } else {
        toast.error(err);
      }

      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.addressData) {
      setFormData(props.addressData);
    }
  }, [props.addressData]);

  return (
    <>
      <form
        className="form position-relative"
        onSubmit={(e) => onSubmit(e, false)}
        autoComplete="off"
      >
        {loading && <OverLoading />}
        <div className="form-group">
          <p className="col-form-label">Name</p>
          <TextField name="name" className="form-control" value={name} multiline onChange={(e) => onChange(e)} />
        </div>
        <div className="form-group">
          <p className="col-form-label">Address *</p>
          <TextField name="address" className="form-control" value={address} multiline onChange={(e) => onChange(e)} />
        </div>
        <div className="form-group">
          <p className="col-form-label">Postal Code *</p>
          <TextField name="postalCode" className="form-control" value={postalCode} multiline onChange={(e) => onChange(e)} disabled={!!props.addressData} />
        </div>
        <div className="form-group">
          <p className="col-form-label">Lat *</p>
          <TextField name="lat" className="form-control" value={lat} multiline onChange={(e) => onChange(e)} />
        </div>
        <div className="form-group">
          <p className="col-form-label">Lng *</p>
          <TextField name="lng" className="form-control" value={lng} multiline onChange={(e) => onChange(e)} />
        </div>
        <div className="form-group">
          <p className="col-form-label">Type</p>
          <TextField name="type" className="form-control" value={type} multiline onChange={(e) => onChange(e)} />
        </div>
        <div className="form-group">
          <input
            type="submit"
            className="btn btn-primary mr-1 d-none"
            value="Save"
            ref={submitButtonRef}
          />
        </div>
      </form>

      <Dialog
        fullWidth
        size="sm"
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">There is an existing address record with the same postal code:</DialogTitle>
        <DialogContent>
          <>
            <ul className="mb-3 list-unstyled" style={{ fontSize: 14, color: Colours.Black, lineHeight: '160%' }}>
              <li>{`Name: ${formData.name}`}</li>
              <li>{`Address: ${formData.address}`}</li>
              <li>{`Postal code: ${formData.postalCode}`}</li>
              <li>{`Lat: ${formData.lat}`}</li>
              <li>{`Lng: ${formData.lng}`}</li>
            </ul>

            <p style={{ fontSize: 14 }}>Proceed to create a new address with the same postal code?</p>
          </>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              setOpenModal(false);
              setLoading(true);
              onSubmit(e, true);
            }}
            color="default"
            className="mr-2"
          >
            Confirm
          </Button>
          <Button onClick={() => setOpenModal(false)} color="primary">Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

FormCreate.propTypes = {
  addressData:           PropTypes.shape({}).isRequired,
  addAddress:            PropTypes.func.isRequired,
  reloadPostalCodeTable: PropTypes.func,
  toggleModal:           PropTypes.func.isRequired,
  updateAddress:         PropTypes.func.isRequired,
  updateList:            PropTypes.func.isRequired,
};

FormCreate.defaultProps = {
  reloadPostalCodeTable: () => true,
};

export default connect(null, { addAddress, updateAddress, toggleModal }, null, {
  forwardRef: true,
})(FormCreate);
